<script setup lang="ts">
defineProps<{
  title: string;
  subtitle: string;
  buttonText: string;
  buttonLink: string;
  backgroundImage?: string;
}>()
</script>

<template>
  <div class="cta-content glass-card px-6 py-12 md:px-12 md:py-20 max-w-5xl mx-auto text-center relative overflow-hidden">
    <!-- Background Image with feathered edges -->
    <div v-if="backgroundImage" 
      class="cta-bg-image" 
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    ></div>
    
    <!-- Fallback glow if no image -->
    <div v-else class="cta-bg-glow absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[radial-gradient(circle,rgba(202,255,1,0.1)_0%,transparent_70%)] pointer-events-none z-0"></div>
    
    <div class="relative z-10">
      <h2 class="gradient-text text-4xl md:text-5xl lg:text-6xl font-bold mb-4">{{ title }}</h2>
      <p class="text-xl md:text-2xl text-white font-medium mb-10">{{ subtitle }}</p>
      <RouterLink :to="buttonLink" class="btn btn-primary">{{ buttonText }}</RouterLink>
    </div>
  </div>
</template>

<style scoped>
.cta-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 0;
  opacity: 0.4;
  /* Feathered edge effect */
  mask-image: radial-gradient(circle at center, black 30%, transparent 75%);
  -webkit-mask-image: radial-gradient(circle at center, black 30%, transparent 75%);
}

/* Ensure glass card doesn't have a solid background that hides the image */
.glass-card {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
}
</style>
